export default function TaxationRulesIconSmall() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M2.97489 1.76562H15.0285C15.0285 1.76562 16.2338 1.76562 16.2338 2.97098V15.0246C16.2338 15.0246 16.2338 16.2299 15.0285 16.2299H2.97489C2.97489 16.2299 1.76953 16.2299 1.76953 15.0246V2.97098C1.76953 2.97098 1.76953 1.76562 2.97489 1.76562Z"
        stroke="#3D3D3D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M2.12109 15.8754L15.8793 2.11719"
        stroke="#3D3D3D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M4.17969 5.98438H7.79576"
        stroke="#3D3D3D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.98828 7.79576V4.17969"
        stroke="#3D3D3D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.8231 12.0078H10.207"
        stroke="#3D3D3D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
